import { useState, useEffect, useRef } from "react";
import Dropdown from "./Dropdown";
import { trackCategoryClick } from "utils/helper/custom";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "assets/images/new-dropdown-icon.svg";
import { useTranslation } from "react-i18next";
import { useAppFont } from "../../utils/helper/useAppFont";

const MenuItems = ({
  items,
  depthLevel,
  handlehamburger,
  handleCategoryClick,
  urlPath,
  isMoreItem,
}) => {
  const [dropdown, setDropdown] = useState(false);
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const productCount = Number(items?.productCount || 0);
  const showArrowOnlyForMore = isMoreItem && Array.isArray(items.submenu) && items.submenu.length > 0;
  const showArrow = items.isTopLevel === true && Array.isArray(items.submenu) && items.submenu.length > 0;
  const { interClass, headingClass, interFamily, headingFamily } = useAppFont();

  let ref = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (
        dropdown &&
        ref.current &&
        !ref.current.contains(event.target)
      ) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    window.innerWidth > 960 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 960 && setDropdown(false);
  };

  const closeDropdown = (item, categoryName = "") => {
    if (window.innerWidth < 961) {
      handlehamburger();
      dropdown && setDropdown(false);
    }
    if (categoryName) {
      trackCategoryClick({ category_name: categoryName });
    }
    if (item && item.url && handleCategoryClick) {
      const urlParts = item.url.split('/').filter(Boolean);
      const id = urlParts[urlParts.length - 1];
      const slug = urlParts[urlParts.length - 2];
      
      handleCategoryClick(item.url);
    }
  };
  if (urlPath) {
      items.url = urlPath;
  }
  const hasSubmenu = items.submenu && items.submenu.length > 0;
  const getArrowRotation = () => {
    if (items.isFromMore) {
    return "rotate-[270deg]";
  }

    return dropdown
      ? "rotate-[180deg]" 
      : "rotate-[0deg]"; 
  };

const isMobile = window.innerWidth < 961;
const isMainCategory = depthLevel === 0;

const menuTextClass = isMobile && isMainCategory
  ? `
    text-[#1A1A1A]
    ${headingClass}
    font-semibold
    leading-[24px]
    text-[15px]
  `
  : isMobile && !isMainCategory
  ? `
    text-[#1A1A1A]
    ${interClass}
    font-normal
    leading-[24px]
    text-[15px]
  `
  : `
    text-[#1A1A1A]
    ${interClass}
    font-normal
    leading-[24px]
    text-[15px]
    sm:text-[16px]
    sm:${headingClass}
    lg:text-[18px]
  `;

  return (
    <li
      className="menu-items  flex flex-row justify-between sm:px-0"
      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    // onClick={closeDropdown}
    >
      {items.url && items.submenu ? (
        <>
          <div
            // type="button"
            // aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={() => setDropdown((prev) => !prev)}
            className={`gap-2 flex flex-row justify-between sm:p-4 p-0 ${interClass} sm:${headingClass} font-normal text-lg`}
          >
            {window.innerWidth < 960 && depthLevel === 0 ? (
              <div className="flex">
                <span className={`flex items-center gap-2 ${menuTextClass}`}>
                  <span className={menuTextClass}>{items.title}</span>

                  {productCount > 0 && (
                    <span
                      className="
                        text-[11px]
                        font-medium
                        text-[#771237]
                        bg-[#FAEBF0]
                        px-2
                        py-[2px]
                        rounded-[5px]
                        leading-none
                      "
                    >
                      {productCount}
                    </span>
                  )}
                </span>
                <div className="w-6 h-6 flex items-center justify-center shrink-0 ml-2">
                  {showArrow ? (
                <ArrowIcon
                  className=
                  {`w-24 h-24 transition-transform duration-300 text-[#771237] ${getArrowRotation()}`}
                />
                  ) : (
                    <span className="w-4 h-4 block" />
                  )}
                </div>
              </div>
            ) : (
              <Link
                to={items.url}
                onClick={(e) => {
                  e.preventDefault();
                  closeDropdown(items, items.title);
                }}
              >
                <span
                  className="flex items-center group hover:text-[#771237]"
                  onClick={() => setDropdown((prev) => !prev)}
                >
                  <span className={`${menuTextClass} hover:text-[#771237]`}>
                    <span className={`flex items-center gap-2 ${menuTextClass}`}>
                      <span className={menuTextClass}>{items.title}</span>

                      {productCount > 0 && (
                        <span
                          className="
                        text-[15px]
                        font-medium
                        text-[#771237]
                        bg-[#FAEBF0]
                        px-2
                        py-[2px]
                        rounded-[5px]
                        leading-none
                      "
                        >
                          {productCount}
                        </span>
                      )}
                    </span>
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 ml-2">
                    {showArrow ? (
                      <ArrowIcon
                        className={`w-24 h-24 transition-transform duration-300 text-[#771237] ${getArrowRotation()}`}
                      />
                    ) : (
                      <span className="w-4 h-4 block" />
                    )}
                  </div>
                </span>
              </Link>
            )}

          </div>
          <Dropdown
            handlehamburger={handlehamburger}
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            handleCategoryClick={handleCategoryClick}
            itemTitle={items.title}
            productCount={productCount}
            isFromMore={items.isFromMore}
            isRTL={isRTL}
          />
        </>
      ) : !items.url && items.submenu ? (
        <>
          <div
            // type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={() => setDropdown((prev) => !prev)}
          >
            <span className="flex items-center group hover:text-[#771237]">
               <span className={`${menuTextClass} hover:text-[#771237]`}>
                <span className={`flex items-center gap-2 ${menuTextClass}`}>
                  <span className={menuTextClass}>
                    {items.title}
                  </span>

                  {productCount > 0 && (
                    <span
                      className="
                        text-[15px]
                        font-medium
                        text-[#771237]
                        bg-[#FAEBF0]
                        px-2
                        py-[2px]
                        rounded-[5px]
                        leading-none
                      "
                    >
                      {productCount}
                    </span>
                  )}
                </span>
              </span>
              <div className="w-6 h-6 flex items-center justify-center shrink-0 ml-2">
                {showArrowOnlyForMore ? (
                <ArrowIcon
                  className={`w-24 h-24 transition-transform duration-300 ${
                    depthLevel > 0 ? "rotate-180 text-[#771237]" : "rotate-0"
                  }`}
                />
                ) : (
                  <span className="w-4 h-4 block" />
                )}
              </div>
            </span>
          </div>
          <Dropdown
            handlehamburger={handlehamburger}
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            handleCategoryClick={handleCategoryClick}
            isFromMore={items.isFromMore}
            isRTL={isRTL}
          />
        </>
      ) : (
        <div className="
          grid 
          grid-cols-[1fr_24px] 
          items-center 
          w-full
          py-2
          sm:py-4
          sm:px-4
        ">
        <Link
          className="hover:text-[#771237]"
          to={items.url}
          onClick={(e) => {
            e.preventDefault();
            closeDropdown(items, items.title);
          }}
        >
            <span className={`flex items-center gap-2`}>
              <span className={menuTextClass}>{items.title}</span>

              {productCount > 0 && (
                <span
                  className="
                text-[15px]
                font-medium
                text-[#771237]
                bg-[#FAEBF0]
                px-2
                py-[2px]
                rounded-[5px]
                leading-none
              "
                >
                  {productCount}
                </span>
              )}
            </span>
        </Link>

          <span className="w-6 h-6 block" />
        </div>
      )}
    </li>
  );
};

export default MenuItems;
